import _ from 'lodash';

/**
 * Service for showing full-page error messages
 */
export class ErrorScreenService {
	/**
	 * @param $rootScope
	 * @param $compile
	 */
	constructor($rootScope, $compile) {
		'ngInject';
		this.$rootScope = $rootScope;
		this.$compile = $compile;
		this.isShowingError = false;
	}

	/**
	 * Show an error screen
	 * @param {Object} details  Info about the error
	 * @property {String} class  The error class (fail|not-found|not-allowed)
	 * @property {String} title  The error message title
	 * @property {String} message  The error message text
	 * @property {String} actionText  The text for the action button
	 * @property {String} detailsText  A stack trace or other technical details of the error
	 * @property {String} [actionUrl]  The destination URL when clicking the button
	 * @property {String} [actionCallback]  A function to call when clicking the button
	 */
	show(details) {
		if (this.isShowingError) {
			console.error('ErrorScreenService: already showing error but new error is', details);
			return;
		}
		this.isShowingError = true;
		let attrs = _.map(details, (value, attr) => {
			if (attr == 'actionCallback') {
				attr = 'actionCallback($event)';
			}
			return `${_.kebabCase(attr)}="vm.${attr}"`;
		}).join(' ');
		let scope = this.$rootScope.$new();
		scope.vm = details;
		// note when error screen is closed
		scope.vm.onClose = () => (this.isShowingError = false);
		// 4. Create an element
		let element = angular.element(`<sh-error-screen ${attrs} on-close="vm.onClose()"></sh-error-screen>`);
		// 5. Compile that element with our scope
		element = this.$compile(element)(scope);
		// optional: append to body if you need it
		document.body.appendChild(element[0]);
	}
}
